import { FormFields } from ".";

export const BANK_DETAILS_FIELDS: FormFields = {
  fields: [
    {
      name: "bankName",
      label: "Bank Name",
      type: "text",
      validationRules: {
        required: "Bank name is required",
      },
    },
    {
      name: "ifsc",
      label: "IFSC Code",
      type: "text",
      validationRules: {
        required: "IFSC code is required",
        pattern: {
          value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
          message: "Please enter a valid IFSC code",
        },
      },
    },
    {
      name: "branchName",
      label: "Branch Name",
      type: "text",
      validationRules: {
        required: "Branch name is required",
      },
    },
    {
      name: "customerId",
      label: "Customer ID",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "accountNumber",
      label: "Account Number",
      type: "text",
      validationRules: {
        required: "Account number is required",
        pattern: {
          value: /^\d{9,18}$/,
          message: "Please enter a valid account number (9-18 digits)",
        },
      },
    },
    {
      name: "accountType",
      label: "Account Type",
      type: "select",
      options: ["SAVINGS", "CURRENT", "CC_OD"],
      validationRules: {
        required: "Account type is required",
      },
    },
  ],
};
